import script from "./MyAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccount.vue?vue&type=script&setup=true&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=053ac6a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053ac6a9"]])

export default __exports__